import { USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE } from '../constants';

export const userOwnedFullLicenseProducts = (
    state = [],
    action
) => {
    switch (action.type) {
        case USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE:
            return action.payload;
        default:
            return state;
    }
};
